import React, { FC, useEffect, useRef } from 'react';

import { Box } from '@opendoor/bricks/core';

import { HELLOSIGN_CLIENT_ID, RAILS_ENV } from 'sellDirect/helpers/closingDash/globals';
import { hellosignInstance as HellosignClient } from 'sellDirect/helpers/closingDash/HellosignClient';
import { useObservability } from 'shared/helpers/observability';

interface HelloSignInnerProps {
  helloSignUrl: string;
  onSign?: () => void;
}

/**
 * TODO: Add documentation
 *
 * storybook-check-ignore
 */
export const HelloSignInner: FC<HelloSignInnerProps> = ({ helloSignUrl, onSign }) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const { trackError } = useObservability();

  useEffect(() => {
    HellosignClient.open(helloSignUrl, {
      allowCancel: false,
      clientId: HELLOSIGN_CLIENT_ID,
      container: modalRef.current ?? undefined,
      skipDomainVerification: RAILS_ENV !== 'production',
    });

    HellosignClient.on('close', () => {
      HellosignClient.off('close');
      HellosignClient.off('sign');
    });

    HellosignClient.on('error', (data) => {
      trackError('hello-sign-embed', new Error(`HelloSign embed error code: ${data.code}`));
    });

    return () => HellosignClient.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [helloSignUrl]);

  useEffect(() => {
    HellosignClient.on('sign', () => onSign && onSign());
  }, [onSign]);

  return <Box width="100vw" height="100%" mx="auto" ref={modalRef} />;
};
